import { useEffect } from 'react'
import { motion } from 'framer-motion'
import { ArrowRight } from 'lucide-react'
import { MarketingNav } from '../components/MarketingNav'
import { useWindowWidth } from '../hooks/useWindowWidth'

// Hochformat-Video (1080×1920), für das Web komprimiert aus produktvideo/out/candlear-produktvideo-pro-sound.mp4
const VIDEO_SRC = '/media/candlear-produktvideo.mp4'
const POSTER_SRC = '/media/candlear-produktvideo-poster.jpg'

function StartCta() {
  return (
    <a
      href="/#start"
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 8,
        fontFamily: 'Plus Jakarta Sans, sans-serif',
        fontSize: 16, fontWeight: 700,
        color: 'white',
        textDecoration: 'none',
        padding: '14px 28px',
        borderRadius: 14,
        background: '#FF6D00',
        boxShadow: '0 8px 32px rgba(255,109,0,0.35), 0 2px 8px rgba(255,109,0,0.2)',
      }}
    >
      Kostenlos starten <ArrowRight size={18} />
    </a>
  )
}

export default function ProduktvideoPage() {
  const isMobile = useWindowWidth() < 900

  useEffect(() => {
    const previous = document.title
    document.title = 'Produktvideo · Candlear'
    window.scrollTo(0, 0)
    return () => { document.title = previous }
  }, [])

  return (
    <div style={{
      position: 'relative',
      minHeight: '100vh',
      overflowX: 'hidden',
      background: 'radial-gradient(ellipse 70% 55% at 70% 45%, rgba(255,109,0,0.14) 0%, rgba(14,11,30,0) 70%), #0E0B1E',
    }}>
      <MarketingNav />

      <main style={{
        maxWidth: 1200,
        margin: '0 auto',
        padding: isMobile ? '96px 16px 56px' : '120px 32px 80px',
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: isMobile ? 32 : 72,
        minHeight: '100vh',
        boxSizing: 'border-box',
      }}>
        {/* Text */}
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.55, ease: [0.25, 0.46, 0.45, 0.94] }}
          style={{ maxWidth: 460, textAlign: isMobile ? 'center' : 'left' }}
        >
          <p style={{
            fontFamily: 'Inter, sans-serif',
            fontSize: 13, fontWeight: 600,
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
            color: '#FF9A00',
            margin: '0 0 16px',
          }}>
            Produktvideo
          </p>
          <h1 style={{
            fontFamily: 'Plus Jakarta Sans, sans-serif',
            fontSize: isMobile ? 34 : 52,
            fontWeight: 800,
            lineHeight: 1.08,
            letterSpacing: '-0.03em',
            color: 'white',
            margin: '0 0 20px',
          }}>
            Candlear in{' '}
            <span style={{
              background: 'linear-gradient(135deg, #FF6D00 0%, #FF9A00 50%, #FFB800 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
            }}>
              50 Sekunden.
            </span>
          </h1>
          <p style={{
            fontFamily: 'Inter, sans-serif',
            fontSize: isMobile ? 16 : 18,
            lineHeight: 1.6,
            color: 'rgba(232,234,246,0.65)',
            margin: isMobile ? 0 : '0 0 32px',
          }}>
            Vom verpassten Anruf zur bestätigten Buchung: Sieh dir an, wie Candlear
            Terminanfragen für dein Business automatisch annimmt.
          </p>
          {!isMobile && <StartCta />}
        </motion.div>

        {/* Video — im Video ist schon ein Handy zu sehen, daher nur eine schlichte Karte */}
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.55, delay: 0.1, ease: [0.25, 0.46, 0.45, 0.94] }}
          style={{
            flexShrink: 0,
            width: isMobile ? 'min(100%, 420px)' : 'min(calc(78vh * 9 / 16), 430px)',
            aspectRatio: '9 / 16',
            borderRadius: 24,
            overflow: 'hidden',
            background: '#000',
            border: '1px solid rgba(101,79,111,0.35)',
            boxShadow: '0 30px 80px rgba(0,0,0,0.55), 0 0 60px rgba(255,109,0,0.12)',
          }}
        >
          <video
            controls
            playsInline
            preload="metadata"
            poster={POSTER_SRC}
            style={{ display: 'block', width: '100%', height: '100%', objectFit: 'cover' }}
          >
            <source src={VIDEO_SRC} type="video/mp4" />
            Dein Browser kann dieses Video nicht abspielen.{' '}
            <a href={VIDEO_SRC} style={{ color: '#FF9A00' }}>Video herunterladen</a>
          </video>
        </motion.div>

        {/* Mobil steht das Video direkt unter der Überschrift, der Button darunter */}
        {isMobile && <StartCta />}
      </main>
    </div>
  )
}
